module.exports = __webpack_public_path__ + "img/thumbnail_basketball_video_preview.3f72c0c1.png";